import { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import {
  DEFAULT_DEALER_REPORT_RANGE,
  trackDealerPerformanceEvent,
} from "../../../constants/automapDealerPerformanceConstants";
import { useDealerPortalIntl } from "../../../hooks/useDealerPortalIntl";
import { fetchDealerLeadPerformance } from "../../../services/automapDealerPerformanceApi";
import { DealerReportsNav, ReportPageHeader, ReportSummaryGrid } from "./DealerPerformanceShared";

export default function DealerLeadPerformanceReportPage() {
  const { dealerId } = useOutletContext();
  const { t, translateError } = useDealerPortalIntl();
  const [range, setRange] = useState(DEFAULT_DEALER_REPORT_RANGE);
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    trackDealerPerformanceEvent("dealer_lead_performance_viewed", { dealerId, range });
  }, [dealerId, range]);

  useEffect(() => {
    setLoading(true);
    fetchDealerLeadPerformance(dealerId, range)
      .then(setPayload)
      .catch((err) => setError(translateError(err.message, "loadReports")))
      .finally(() => setLoading(false));
  }, [dealerId, range]);

  const totals = payload?.totals;
  const response = payload?.response;

  return (
    <div className="dealer-reports">
      <DealerReportsNav active="leads" />
      <ReportPageHeader
        title={t("reports.leadPerformance")}
        description={t("reports.leadPerformanceDesc")}
        dealerId={dealerId}
        range={range}
        onRangeChange={setRange}
      />
      {loading ? <p className="dealer-state-box">{t("reports.loading")}</p> : null}
      {error ? <p className="dealer-state-box">{error}</p> : null}
      {!loading && !error && totals ? (
        <>
          <ReportSummaryGrid
            items={[
              { label: "Total leads", value: totals.total },
              { label: "Nuevos", value: totals.new },
              { label: "Contactados", value: totals.contacted },
              { label: "Calificados", value: totals.qualified },
              { label: "Malos", value: totals.bad },
              { label: "Duplicados", value: totals.duplicate },
              {
                label: "Tasa de respuesta",
                value: response?.responseRate != null ? `${response.responseRate}%` : "Sin datos suficientes",
              },
              {
                label: "Tiempo promedio",
                value: response?.averageResponseTimeLabel || "Sin datos suficientes",
              },
            ]}
          />
          <div className="dashboard-main-grid">
            <section className="dealer-state-box">
              <h3>Leads por fuente</h3>
              <ul className="dashboard-checklist">
                {(payload.bySource || []).map((row) => (
                  <li key={row.key}>
                    {row.key}: {row.count}
                  </li>
                ))}
              </ul>
            </section>
            <section className="dealer-state-box">
              <h3>Leads por publicación</h3>
              <ul className="dashboard-checklist">
                {(payload.byListing || []).map((row) => (
                  <li key={row.key}>
                    {row.key}: {row.count}
                  </li>
                ))}
              </ul>
            </section>
          </div>
          <Link className="dealer-portal-btn primary" to="/v/automap/dealer/leads">
            Ir al inbox de leads
          </Link>
        </>
      ) : null}
    </div>
  );
}
